module.exports = __webpack_public_path__ + "img/trial3-1.903e9c19.png";